import { apiSlice } from '../../api/apiSlice';

export const pdfGeneratorApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    pdfGenerator: builder.mutation({
      query: (option) => ({
        url: 'PdfGenerator',
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: option,
        responseHandler: (response) => response.blob()
      }),
      extraOptions: { showGlobalError: true }
    }),
    studentPdfGenerator: builder.mutation({
      query: (options) => ({
        url: 'AssignmentPrint/GenerateStudentPDF',
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: options,
        responseHandler: async (response) => {
          if (!response.ok) {
            const errorText = await response.text();
            throw new Error(errorText || 'PDF generation failed');
          }
          const blob = await response.blob();
          return blob;
        }
      }),
      extraOptions: { showGlobalError: true }
    }),
    checkIsStudentPdfExist: builder.mutation({
      query: (options) => ({
        url: 'AssignmentPrint/Assignment/studentPdfExist',
        method: 'POST',
        credentials: 'include',
        body: options
      }),
      extraOptions: { showGlobalError: true }
    }),
    viewStudentPdf: builder.mutation({
      query: (options) => ({
        url: `AssignmentPrint/ViewStudentPDF/Assignment/${options.assignmentId}`,
        method: 'GET',
        credentials: 'include',
        responseHandler: async (response) => {
          if (!response.ok) {
            const errorText = await response.text();
            throw new Error(errorText || 'PDF generation failed');
          }
          const blob = await response.blob();
          return blob;
        },
      }),
      extraOptions: { showGlobalError: true }
    })
  })
});

export const {
  usePdfGeneratorMutation,
  useStudentPdfGeneratorMutation,
  useCheckIsStudentPdfExistMutation,
  useViewStudentPdfMutation
} = pdfGeneratorApi;